import type { AssessmentRunDataFragment, ProgramListItemDataFragment } from './ProgramListing.api';
import { ProgramSortingField } from '@/apolloClient.types';

export interface ProgramListingItemGroup {
    programId: string;
    groupId: string;
    name: string;
    assessmentRuns: AssessmentRunDataFragment[];
    startDate: string | Date;
    endDate: string | Date;
}

export interface ProgramListingItem extends ProgramListItemDataFragment {
    groups: ProgramListingItemGroup[];
}

// Define column keys for program table
export enum ProgramColumnKey {
    ProgramName = 'programName',
    Description = 'description',
    CourseName = 'courseName',
    CreatedAt = 'createdAt',
    Actions = 'actions',
}

// Define subcolumns for program table
export enum ProgramSubColumnKey {
    GroupName = 'groupName',
    AssessmentRuns = 'assessmentRuns',
    StartDate = 'startDate',
    EndDate = 'endDate',
}

// Map column keys to GraphQL sort fields
export const getSortField = (columnKey: ProgramColumnKey): ProgramSortingField | null => {
    switch (columnKey) {
        case ProgramColumnKey.ProgramName:
            return ProgramSortingField.Name;
        case ProgramColumnKey.Description:
            return ProgramSortingField.Description;
        case ProgramColumnKey.CourseName:
            return ProgramSortingField.CourseInstanceName;
        case ProgramColumnKey.CreatedAt:
            return ProgramSortingField.CreatedAt;
        default:
            return null;
    }
};
